import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button, Dropdown, Input } from 'semantic-ui-react';
import { setSnackbar } from '../../actions/snackbar.actions';
import { sysAPI } from '../../apis/SysAPI';

const Filters = ({filters = {}, setFilters = () => {}, handlerSearch = () => {}, handlerDownload = () => {}, filterButtonIsDisabled, loading, loadingDownload}) => {
    const dispatch = useDispatch();
    const [allCompanies, setAllCompanies] = useState([])
    const [optionsMainCompanies, setOptionsMainCompanies] = useState([])
    const [mainSelected, setMainSelected] = useState([])
    const [officeSelected, setOfficeSelected] = useState([])
    const [optionsOffices, setOptionsOffices] = useState([])
    const licenseList = [
        { text: '', value: '', key: -1 },
        { text: 'Trial', value: 'Trial', key: 1 },
        { text: 'Licensed/Active', value: 'Licensed/Active', key: 2 },
        { text: 'Other', value: 'Other', key: 3 },
        // {text: 'Purchased license', value: 'purchasedLicense', key: 1},
        // {text: 'On Free Trial', value: 'onFreeTrial', key: 2},
        // {text: 'With Current Free Trial', value: 'currentFreeTrial', key: 3},
        // {text: 'With Expired Free Trial', value: 'expiredFreeTrial', key: 4}
    ];
    const businessCategoriesOptions = [
        {
            value: '',
            text: '',
        },
        {
            value: 'implementation',
            text: 'Implementation',
        },
        {
            value: 'adoption',
            text: 'Adoption',
        },
        {
            value: 'growth',
            text: 'Growth',
        },
        {
            value: 'maintenance',
            text: 'Maintenance',
        },
    ];

    const getCompanies = async () => {
        try {
            const {data} = await sysAPI.get(`/companies`);
            const aux_all_companies = data.companies.map(company => {
                return {
                    key: company._id,
                    value: company._id,
                    text: company.name,
                    ...company
                }
            })
            setAllCompanies(aux_all_companies)

            const mainCompanies = aux_all_companies.filter(company => company.isMainOffice)
            mainCompanies.unshift({ key: 'all', text: 'All', value: 'All' })
            setOptionsMainCompanies(mainCompanies)
        } catch (error) {
            const message = error?.response?.data?.message || error?.message || "Oops... something is wrong..."
            console.error(error);
            dispatch(setSnackbar({message, status: "error"}))
        }
    }

    const handlerChangeMainCompanies = (values) => {
        let offices = []
        if(values.includes('All')){
            setMainSelected(["All"])
            const DisabledOptionsMainCompanies = JSON.parse(JSON.stringify(optionsMainCompanies)).map(e => {
                e.disabled = true
                return e
            })
            setOptionsMainCompanies(DisabledOptionsMainCompanies)
            offices = allCompanies.filter(company => !company.isMainOffice)
        }else{
            setMainSelected(values)
            const DisabledOptionsMainCompanies = JSON.parse(JSON.stringify(optionsMainCompanies)).map(e => {
                e.disabled = false
                return e
            })
            setOptionsMainCompanies(DisabledOptionsMainCompanies)
            offices = allCompanies.filter(company => !company.isMainOffice).map(company => {
                const mainOffice = DisabledOptionsMainCompanies.find(main => main.offices?.includes(company._id))
                if(mainOffice){
                    company.mainOffice = mainOffice
                    company.text = `${company.name} [${mainOffice.name} (${mainOffice.offices.length})]`
                }
                return company
            }).filter(company => values.includes(company.mainOffice._id))

            console.log({offices,values})
        }

        if(offices.length){
            offices.unshift({ key: 'all', text: 'All', value: 'All' })
        }

        offices = offices.map(company => {
            const mainOffice = optionsMainCompanies.find(main => main.offices?.includes(company._id))
            if(mainOffice){
                company.mainOffice = mainOffice
                company.text = `${company.name} [${mainOffice.name} (${mainOffice.offices.length})]`
            }
            return company
        })
        setOptionsOffices(offices)

        if(filters.officeCompanies?.length){
            const auxOfficeCompanies = filters.officeCompanies.filter(idCompany => offices.map(e => e._id).includes(idCompany))
            console.log({auxOfficeCompanies})
        }
    }

    const handlerChangeOffices = (values) => {
        if(values.includes('All')){
            setOfficeSelected(["All"])
            const DisabledoptionsOffices = JSON.parse(JSON.stringify(optionsOffices)).map(e => {
                e.disabled = true
                return e
            })
            setOptionsOffices(DisabledoptionsOffices)
        }else{
            setOfficeSelected(values)
            const DisabledoptionsOffices = JSON.parse(JSON.stringify(optionsOffices)).map(e => {
                e.disabled = false
                return e
            })
            setOptionsOffices(DisabledoptionsOffices)
        }
    }

    useEffect(() => {
        const officeCompanies = []
        if(officeSelected.includes("All")){
            officeCompanies.push(...optionsOffices.map(e => e._id).filter(e => e))
        }else{
            officeCompanies.push(...officeSelected)
        }

        setFilters({...filters || {}, mainCompanies: mainSelected, officeCompanies})

        // eslint-disable-next-line
    },[mainSelected, officeSelected])

    useEffect(() => {
        getCompanies()

        // eslint-disable-next-line
    },[])
    return (
        <>
            <div className="flex flex-space-between gap-5 mb-2">
                <div className="flex-10" style={{ width: '100%' }}>
                    <Input
                        value={filters.searchInput}
                        onChange={(_, {value}) => setFilters({...filters || {}, searchInput: value})}
                        icon="search"
                        iconPosition="left"
                        fluid
                        onKeyPress={e => (e.charCode === 13 || e.keyCode === 13 || e.which === 13) && handlerSearch()}
                    />
                </div>
                <div className="flex-1">
                    <Button disabled={loading || loadingDownload || filterButtonIsDisabled} loading={loadingDownload} style={{width:"100%"}} onClick={() => handlerDownload()}>Download</Button>
                </div>
                <div className="flex-1">
                    <Button disabled={loading || loadingDownload || filterButtonIsDisabled} loading={loading} style={{width:"100%"}} onClick={() => handlerSearch()}>Filter</Button>
                </div>
            </div>
            <div className="flex flex-space-between gap-5">
                <div className="flex-3" style={{ width: '100%' }}>
                    <Dropdown
                        style={{width:"100%"}}
                        placeholder='Include Main Companies'
                        multiple
                        selection
                        search
                        options={optionsMainCompanies}
                        value={mainSelected}
                        onChange={(_, {value}) => handlerChangeMainCompanies(value)}

                    />
                </div>
                <div className="flex-3">
                    <Dropdown
                        style={{width:"100%"}}
                        placeholder='Include Office Companies'
                        multiple
                        selection
                        search
                        options={optionsOffices}
                        value={officeSelected}
                        onChange={(_, {value}) => handlerChangeOffices(value)}
                    />
                </div>
                <div className="flex-3">
                    <Dropdown
                        style={{width:"100%"}}
                        placeholder='Exclude Companies & Offices'
                        multiple
                        selection
                        search
                        options={allCompanies.map(e => { delete e.disabled; return e})}
                        value={filters.excludeCompanies}
                        onChange={(_, {value}) => setFilters({...filters || {}, excludeCompanies: value})}
                    />
                </div>
                <div className="flex-3">
                    <Dropdown
                        style={{ width: '100%' }}
                        placeholder="License Type"
                        selection
                        search
                        options={licenseList}
                        value={filters.license}
                        onChange={(_, {value}) => setFilters({...filters || {}, license: value})}
                    />
                </div>
                <div className="flex-3">
                    <Dropdown
                        style={{ width: '100%' }}
                        placeholder="Business Categories"
                        selection
                        options={businessCategoriesOptions}
                        value={filters.businessCategory}
                        onChange={(_, {value}) => setFilters({...filters || {}, businessCategory: value})}
                    />
                </div>
            </div>
        </>
    );
};

export default Filters;
